import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowRight, X } from "lucide-react";

export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show CTA after scrolling 300px down
      const scrolled = window.scrollY > 300;
      setIsVisible(scrolled && !isDismissed);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isDismissed]);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 w-full max-w-md px-4 md:hidden animate-fade-in">
      <div className="bg-primary text-primary-foreground rounded-full shadow-lg p-4 flex items-center justify-between gap-3">
        <Link to="/auth?tier=free" className="flex-1">
          <Button 
            size="sm" 
            variant="secondary" 
            className="w-full h-12 text-sm font-semibold rounded-full"
          >
            Start 7-Day Free Trial
            <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
        </Link>
        <button
          onClick={() => setIsDismissed(true)}
          className="p-2 hover:bg-primary-foreground/20 rounded-full transition-colors"
          aria-label="Dismiss"
        >
          <X className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
}
